module.exports = {"Type":"Telemetry","Fields":[{"label":"Event name","name":"name","serializeTo":"node"},{"label":"Value","type":"multiline","name":"text","serializeTo":"q"},{"label":"Log latest User message","type":"yesno","name":"isUserMessageLogEnabled","advanced":true,"description":"Log latest User message","defaultValue":"No"}],"Header":{"Color":"black","BackgroundColor":"#6d6525","Text":"Telemetry"}}


//////////////////
// WEBPACK FOOTER
// ./src/designer/widgets/Telemetry.json
// module id = 710
// module chunks = 0